import { EmitService } from './../../../../core/services/utils/emit.service';
import { TurnosService } from './../../../../core/services/http/turnos.service';
import { LocalService } from './../../../../core/services/storage/local.service';
import { EstadosService } from './../../../../core/services/http/estados.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { Component, OnInit } from '@angular/core';
import { SweetAlertService } from 'src/app/core/services/utils/sweet-alert.service';

@Component({
  selector: 'app-modal-derivar-atencion',
  templateUrl: './modal-derivar-atencion.component.html',
  styleUrls: ['./modal-derivar-atencion.component.css']
})
export class ModalDerivarAtencionComponent implements OnInit {
  idTurno: any;
  serieActual: any;
  derivarForm!: FormGroup;
  emiStatus: any;
  derivarIsSubmitted = false;
  accion: any;
  escritorio: any;
  seriesADerivar: any;
  derivado: any;

  constructor(
    private modalService: ModalService,
    private estados: EstadosService,
    private localSecureService: LocalService,
    private formBuilder: FormBuilder,
    private turnos: TurnosService,
    private emit: EmitService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
    this.escritorio = this.localSecureService.getValue('escritorio');
    this.getSeries();
    this.setFormDerivar();
  }

  /* Obtiene las series correspondiente a esa oficina */
  async getSeries() {
    const idOficina = this.escritorio.idOficina;
    await this.estados.getSeries(idOficina).then((data) => {
      const emiStatus: any = data;
      this.emiStatus = emiStatus.getSeriesaDerivar;
    });
    this.seriesADerivar = this.emiStatus.filter((series: any) => {
      return series.idSerie !== this.serieActual;
    });
  }

  setFormDerivar() {
    this.derivarForm = this.formBuilder.group({
      serie: [null, [Validators.required]],
      accion: ['1', [Validators.required]],
    });
  }

  async onSubmitDerivar() {
    if(!this.localSecureService.getValue('consultora')) {
      this.sweetAlertService.swalInternet();
      return;
    }

    this.derivarIsSubmitted = true;

    if (this.derivarForm.invalid) {
      return;
    }

    const data = {
      "idTurno": this.idTurno,
      "idSerie": this.derivarForm.value.serie.idSerie,
      "parametros": ""
    }

    await this.turnos.derivarTurno(data).then((data: any) => {
      this.derivado = data;
    });

    if (this.derivado.info) {
      switch (this.derivarForm.value.accion) {
        case '1':
          this.closeModal();
          this.emit.enviarData('continuar');
          break;
        case '2':
          this.closeModal();
          this.emit.enviarData('pausa');
          break;
        case '3':
          this.closeModal();
          this.emit.enviarData('cierreDeriva');
          break;
      }
    } else {
      this.closeModal();
      this.emit.enviarData('failPausa');
    }

  }

  closeModal(): void {
    this.modalService.closeModal();
  }

}
